import 'angular';

import '../api/api.module.ajs';
import '../core/core.module.ajs';
import './beta-warning/beta-warning.module.ajs';
import './critical-messages/critical-messages.module.ajs';
import './customer-messages/customer-messages.module.ajs';
import './notifications/notifications.module.ajs';


import {
  downgradeComponent,
  downgradeInjectable }
 from '@angular/upgrade/static';

import { ConfirmService }    from './confirm/confirm.service';
import { MessagesComponent } from './messages.component';
import { MessagesService }   from './messages.service';
import { MessengerService }  from './messenger/messenger.service';

angular.module('app-lite.messages', [
  'app-lite.api',
  'app-lite.core',
  'app-lite.messages.beta-warning',
  'app-lite.messages.critical-messages',
  'app-lite.messages.customer-messages',
  'app-lite.messages.notifications'
]).directive('worMessages', downgradeComponent({ component: MessagesComponent }))
  .service('confirm', downgradeInjectable(ConfirmService))
  .service('messages', downgradeInjectable(MessagesService))
  .service('messengerApi', downgradeInjectable(MessengerService));
